import React from "react";
import Nav from "./Nav";

import MobileNav from "./MobileNav";
import { Link } from "react-router-dom";
import "../styles/Header.scss";

class Header extends React.Component {
  render() {
    return (
      <header>
        <Link to={`${process.env.PUBLIC_URL}`} className="logo">
          <span className="serif-italic-font">Estelle Leeds</span>
          <br />
          <span className="serif-italic-font logoSub">
            FOUNDER / CEO / EXECUTIVE PRODUCER
          </span>
        </Link>
        <Nav />
        <div className="mobile-nav-container">
          <MobileNav />
        </div>
      </header>
    );
  }
}

export default Header;
